import {Component, LayoutOptions} from "@mecatran-components/component";
import tableTemplate from "./table.template.njk";
import nunjucks from "nunjucks/browser/nunjucks-slim.js";

export class Table extends Component{
    constructor(tableOptions){
        if (!tableOptions) throw new Error('Table Component: constructor options are mandatory')
        super();

        this.initTable(tableOptions);
    }

    // ===========
    // private 
    // ----------

    initTable(tableOptions){
        var dataTable = tableOptions.dataTable;
        if (dataTable){
            var context = { 
                dataTable, 
                printString : Table.printString  
            }
            var layoutOptions = new LayoutOptions(tableTemplate, context);
            this.setContentOptions(layoutOptions);
    
            this.getDomManager().buildContent(layoutOptions);
            this.build();
        }
    }

    // ==========
    // overloaded
    // ----------
    createContainerNode(){
        var div = document.createElement('div');
        div.classList.add('table');
        return div;
    }

    // ==========
    // static 
    // ----------
    static printString(str){
        return new nunjucks.runtime.SafeString(str);
    }
}


/**
 * dataTable is an instance of DataTable 
 */
class TableOptions{
    constructor(){
        this.dataTable; 
    }
}